let buttons = Array.from(document.querySelectorAll(".js-recommanded-option"));
let totalAddedOptions = JSON.parse(document.getElementById("options-block").dataset.addedOptions).length;
const moreOptionsMessage = JSON.parse(document.getElementById("orange-telesurveillance-configurator-page").dataset.moreOptionsMessage);
const lessOptionsMessage = JSON.parse(document.getElementById("orange-telesurveillance-configurator-page").dataset.lessOptionsMessage);
const moreOptionsButton = document.getElementById('button-more-options');

// tms
const tmsCategory = 'configurateur';
const tmsDiscountCodeAction = 'code_promotionnel';
function tmsTag(category, action, label) {
    return {
        category: category,
        action: action,
        label: label
    }
}

// Si la clé de conf isUnfolded est à true, le code promo doit être déplié à l'affichage de la page :
let discountCodeLink = document.getElementById("discount-code-header");
if (discountCodeLink.getAttribute("data-is-unfolded") === "true") {
    discountCodeLink.classList.remove("collapsed");
    discountCodeLink.setAttribute("aria-expanded","true");
    document.getElementById("discount-code").classList.add("show");
}

document.addEventListener('DOMContentLoaded', (e) => {
    document.querySelectorAll('.radio-offer input').forEach((r) => {
        r.addEventListener("change", () => window.location.href = r.dataset.href);
    });
    if (document.getElementById("discount-code-input").value) {
        $(`#discount-code-input`).addClass('hidden')
        $(`#discount-code`).addClass('show');
        $(`#discount-code-success`).removeClass('hidden');
    }
    if (totalAddedOptions > 0) {
        $('#options-block').removeClass('hidden');
    }
});

$(".js-recommanded-option").click(function (event) {
    event.preventDefault();
    let optionsButton = $(this);
    let url = optionsButton.data('url');
    let id = optionsButton.data('id');
    let addLabel = optionsButton.data('add-label');
    let removeLabel = optionsButton.data('remove-label');
    let idButton = `addButton${id}`;
    let buttonDesktop = document.getElementById(`${idButton}-desktop`);
    let buttonMobile = document.getElementById(`${idButton}-mobile`);

    // gestion ajout option
    if (buttonDesktop.innerHTML === addLabel) {
        $.ajax({
            method: "PUT",
            timeout: myshop.wsTimeout,
            dataType: "json",
            url: url,
            beforeSend: function () {
                $(`#spinner${id}`).removeClass('hidden');
                $(`#error${id}`).addClass('hidden');
            }
        }).done(function (response) {
            if (response.status === 'OK') {
                $(`#spinner${id}`).addClass('hidden');
                totalAddedOptions = totalAddedOptions + 1;

                // traitement affichage option ajoutée ou supprimée
                $('#options-block').removeClass('hidden');
                const option = response.option;
                const recurringPrice = option.discountedRecurringPrice != null ? option.discountedRecurringPrice : option.recurringPrice
                const displayedRecurringPrice = option.isFree ? "Offert" : recurringPrice;
                const recurringPriceSrOnly = option.isFree ? `Offert au lieu de ${option.recurringPrice} par mois` : `${recurringPrice} par mois`;
                const priceByMonthLabel = option.isFree ? "" : " /mois";
                const discountDuration = option.discountDuration ? `pendant ${option.discountDuration.duration} mois` : "";
                const initialRecurringPrice = option.isForeverDiscounted ? `au lieu de ${option.recurringPrice} /mois` : (option.discountDuration ? `puis ${option.recurringPrice} /mois` : "");

                $("#optionCart").append(
                    `<div class="col-12" id="addedOption${id}">
                        <div class="row p-0">
                            <div class="col-8 lead fw-bold d-flex align-items-center">
                                <p class="mb-0 fw-bold">${option.label}</p>
                            </div>
                            <div class="col-4 d-flex align-items-center justify-content-end text-end">
                                <div id="prix${id}" class="ob1-price ob1-price-mini" data-ob1-component="Price" data-ref-price="Price${id}">
                                    <p class="visually-hidden">${recurringPriceSrOnly}</p>
                                    <p aria-hidden="true">
                                        <span class="ob1-price-amount">${displayedRecurringPrice}</span><span class="ob1-price-by-month">${priceByMonthLabel}</span>
                                        <span class="ob1-price-promo-duration">
                                          <span class="${option.discountDuration != null ? '' : 'hidden'}">${discountDuration}</span>
                                          <span class="ob1-price-promo-duration-by-month ${initialRecurringPrice != '' ? '' : 'hidden'}">${initialRecurringPrice}</span>
                                        </span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>`
                );

                updateTotalRecurringPrice(response.newTotalRecurringPrice);

                // traitement mise à jour des boutons sur options
                [buttonMobile, buttonDesktop].forEach(b => {
                    b.innerText = removeLabel;
                    b.classList.remove('btn-secondary');
                    b.classList.add('btn-primary');
                });
                $(`#option-img-${id}`).addClass('hidden');
                $(`#added-img-${id}`).removeClass('hidden');

            } else if (response.status === 'KO') {
                $(`#spinner${id}`).addClass('hidden');
                $(`#error${id}`).removeClass('hidden');
                setTimeout(function () {
                    $(`#error${id}`).addClass('hidden');
                }, 1500);
            }
        }).fail(function () {
            $(`#spinner${id}`).addClass('hidden');
            $(`#error${id}`).removeClass('hidden');
            setTimeout(function () {
                $(`#error${id}`).addClass('hidden');
            }, 1500);
        });


    }

    // gestion suppression option
    if (buttonDesktop.innerHTML === removeLabel) {
        $.ajax({
            method: "DELETE",
            timeout: myshop.wsTimeout,
            dataType: "json",
            url: url,
            beforeSend: function () {
                $(`#spinner${id}`).removeClass('hidden');
                $(`#error${id}`).addClass('hidden');
            }
        }).done(function (response) {
            if (response.status === 'OK') {
                $(`#spinner${id}`).addClass('hidden');
                totalAddedOptions = totalAddedOptions - 1;

                // traitement affichage option ajoutée ou supprimée
                $(`#addedOption${id}`).remove();
                if (totalAddedOptions == "0") {
                    $('#options-block').addClass('hidden');
                }

                // mise à jour du prix total
                updateTotalRecurringPrice(response.newTotalRecurringPrice);

                // traitement mise à jour des boutons sur options
                [buttonMobile, buttonDesktop].forEach(b => {
                    b.innerText = addLabel;
                    b.classList.add('btn-secondary');
                    b.classList.remove('btn-primary');
                });

                $(`#added-img-${id}`).addClass('hidden');
                $(`#option-img-${id}`).removeClass('hidden');

            } else if (response.status === 'KO') {
                $(`#spinner${id}`).addClass('hidden');
                $(`#error${id}`).removeClass('hidden');
                setTimeout(function () {
                    $(`#error${id}`).addClass('hidden');
                }, 1500);
            }
        }).fail(function () {
            $(`#spinner${id}`).addClass('hidden');
            $(`#error${id}`).removeClass('hidden');
            setTimeout(function () {
                $(`#error${id}`).addClass('hidden');
            }, 1500);
        });
    }

});

$(`#discount-code-input`).click(function (event) {
    event.preventDefault();
    $(`#discount-code-error`).addClass('hidden');
    $(`#discount-code-input`).removeClass('is-invalid')
    $(`#discount-code-input`).removeClass('form-control-empty')
    $(`#discount-code-input`).addClass('form-control-empty')
    $(`#discount-code-add`).removeClass('hidden');
});

// code promo : clic sur le bouton 'ajouter' ou touche 'Entrée'
function codeInputListener(event) {
    event.preventDefault();
    let addUrl = document.getElementById("discount-code-add").dataset.addUrl;
    let discountCodeInput = document.getElementById("discount-code-input").value;
    Tms.link(tmsTag(tmsCategory, tmsDiscountCodeAction, 'ajouter'));
    $.ajax({
        method: "PUT",
        timeout: myshop.wsTimeout,
        url: `${addUrl}/${discountCodeInput}`,
        beforeSend: function () {
            $(`#discount-code-spinner`).removeClass('hidden');
            $(`#discount-code-success`).addClass('hidden');
        }
    }).done(function (response) {
        if (response.status === 'OK') {
            $(`#discount-code-spinner`).addClass('hidden');
            updateOfferPrice(response.newOfferPrice);
            updateTotalRecurringPrice(response.newTotalRecurringPrice);
            $(`#discount-code-add`).addClass('hidden');
            $(`#discount-code-error`).addClass('hidden');
            $(`#discount-code-success-text`).text(response.validCodeMessage);
            $(`#discount-code-success`).removeClass('hidden');
            $(`#discount-code-input`).addClass('hidden');
            $(`#discount-code-input`).removeClass('is-invalid');
            $(`#discount-code-input`).addClass('form-control-empty');
            Tms.link(tmsTag(tmsCategory, tmsDiscountCodeAction, 'ok'));
        } else if (response.status === 'KO') {
            $(`#discount-code-spinner`).addClass('hidden');
            $(`#discount-code-error`).removeClass('hidden');
            $(`#discount-code-input`).removeClass('form-control-empty');
            $(`#discount-code-input`).addClass('is-invalid');
            Tms.link(tmsTag(tmsCategory, tmsDiscountCodeAction, 'ko'));
        }
    }).fail(function () {
        $(`#discount-code-spinner`).addClass('hidden');
        $(`#discount-code-error`).removeClass('hidden');
        $(`#discount-code-input`).removeClass('form-control-empty');
        $(`#discount-code-input`).addClass('is-invalid');
        Tms.link(tmsTag(tmsCategory, tmsDiscountCodeAction, 'ko'));
    });
}
$(`#discount-code-add`).click(function (event) {
    codeInputListener(event);
});
$(`#discount-code-input`).keydown(function (event) {
    if (event.key === "Enter") codeInputListener(event);
});

$(`#discount-code-remove`).click(function (event) {
    event.preventDefault();
    let removeUrl = document.getElementById("discount-code-remove").dataset.removeUrl;
    $.ajax({
        method: "DELETE",
        timeout: myshop.wsTimeout,
        url: `${removeUrl}`,
        beforeSend: function () {
            $(`#discount-code-spinner`).removeClass('hidden');
        }
    }).done(function (response) {
        if (response.status === 'OK') {
            $(`#discount-code-spinner`).addClass('hidden');
            updateOfferPrice(response.newOfferPrice);
            updateTotalRecurringPrice(response.newTotalRecurringPrice);
            $(`#discount-code-input`)[0].value = "";
            $(`#discount-code-add`).removeClass('hidden');
            $(`#discount-code-success`).addClass('hidden');
            $(`#discount-code-input`).removeClass('hidden')
        } else if (response.status === 'KO') {
            $(`#discount-code-spinner`).addClass('hidden');
        }
    }).fail(function () {
        $(`#discount-code-spinner`).addClass('hidden');
    });
});

function updateTotalRecurringPrice(newTotalRecurringPrice) {
    $(`#totalPrice`).html(
        `<p class="visually-hidden">${newTotalRecurringPrice.srOnly}</p>
            <p aria-hidden="true">
                <span class="ob1-price-amount">${newTotalRecurringPrice.price}</span>
                <span class="ob1-price-promo-duration">${newTotalRecurringPrice.priceDetails}</span>
            </p>`
    );
}

function updateOfferPrice(newOfferPrice) {
    $(`#offerPrice`).html(
        `<p class="visually-hidden">${newOfferPrice.srOnly}</p>
            <p aria-hidden="true">
                <span class="ob1-price-amount">${newOfferPrice.price}</span>
                <span class="ob1-price-promo-duration">${newOfferPrice.priceDetails}</span>
            </p>`
    );
}

if (moreOptionsButton !== null) {
    moreOptionsButton.addEventListener("click", function (event) {
        if (moreOptionsButton.innerHTML === moreOptionsMessage) {
            moreOptionsButton.innerHTML = lessOptionsMessage;
        } else {
            moreOptionsButton.innerHTML = moreOptionsMessage;
        }
    });
}
